import { request } from "utils/api";

export function show(answerId: number) {
  return request(`/questionnaire_answer_authorizations/${answerId}`, {
    method: "GET"
  });
}
